import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SellerLayout from './SellerLayout';

const SellerProductView = () => {
  const [loading, setLoading] = useState(true);
  const [shopName, setShopName] = useState('');
  const [shopId, setShopId] = useState(null);
  const [product, setProduct] = useState(null);
  const [descriptionHtml, setDescriptionHtml] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const id = Number(params.get('id') || 0);

        const res = await axios.get(
          `/api/seller/product/view-data?id=${encodeURIComponent(id)}`,
          { withCredentials: true }
        );

        if (res.data && res.data.ok) {
          setShopId(res.data.shop_id);
          setShopName(res.data.shop_name || '');
          setProduct(res.data.product);
          setDescriptionHtml(res.data.description_html || '');
        } else {
          alert(res.data?.error || '상품 정보를 불러오지 못했습니다.');
        }
      } catch (err) {
        const redirect = err?.response?.data?.redirect;
        const error = err?.response?.data?.error;

        if (redirect) {
          window.location.href = redirect;
          return;
        }

        alert(error || '상품 정보를 불러오지 못했습니다.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleDelete = async () => {
    const ok = window.confirm('정말 삭제하시겠습니까?');
    if (!ok || !product) return;

    try {
      const res = await axios.post(
        '/api/seller/product/delete-process',
        { id: product.id },
        { withCredentials: true }
      );

      if (res.data && res.data.ok) {
        alert(res.data.message || '상품이 삭제되었습니다.');
        window.location.href = res.data.redirect || '/seller/product/list';
        return;
      }

      alert(res.data?.error || '삭제 실패');
    } catch (err) {
      alert(err?.response?.data?.error || '삭제 실패');
    }
  };

  const formatNumber = (value) => {
    return Number(value || 0).toLocaleString('ko-KR');
  };

  if (loading) {
    return (
      <SellerLayout shopName={shopName}>
        <div style={styles.loadingWrap}>로딩중...</div>
      </SellerLayout>
    );
  }

  if (!product) {
    return (
      <SellerLayout shopName={shopName}>
        <div style={styles.loadingWrap}>상품이 없습니다.</div>
      </SellerLayout>
    );
  }

  return (
    <SellerLayout shopName={shopName}>
      <div style={styles.topSpace}></div>

      <h2 style={styles.title}>상품 상세보기</h2>

      <h3 style={styles.productName}>상품명:{product.name}</h3>

      {product.image_path ? (
        <img
          src={`/static/${String(product.image_path).replace(/^\/+/, '')}`}
          alt=""
          style={styles.productImage}
        />
      ) : null}

      <div><strong>가격:</strong> {formatNumber(product.price || 0)}원</div>
      <div><strong>재고:</strong> {product.stock}개</div>
      <div><strong>등록일:</strong> {product.created_at}</div>

      <div style={styles.sectionGap}></div>

      <div><strong>간단설명:</strong></div>
      <p>{product.short_description}</p>

      <div><strong>상세설명:</strong></div>
      <div
        style={styles.descriptionWrap}
        dangerouslySetInnerHTML={{ __html: descriptionHtml }}
      />

      <div style={styles.actionRow}>
        {shopId ? (
          <>
            <a href={`/seller/product/edit?id=${product.id}`} style={styles.actionLink}>
              ✏️ 수정
            </a>
            <span>|</span>
            <button type="button" onClick={handleDelete} style={styles.deleteButton}>
              🗑️ 삭제
            </button>
          </>
        ) : null}
      </div>
    </SellerLayout>
  );
};

const styles = {
  loadingWrap: {
    padding: '40px 0',
  },
  topSpace: {
    height: '16px',
  },
  title: {
    marginBottom: '24px',
  },
  productName: {
    marginBottom: '16px',
  },
  productImage: {
    width: '300px',
    maxWidth: '100%',
    display: 'block',
    marginBottom: '20px',
  },
  sectionGap: {
    height: '16px',
  },
  descriptionWrap: {
    marginTop: '8px',
  },
  actionRow: {
    marginTop: '20px',
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
  },
  actionLink: {
    color: '#0d6efd',
    textDecoration: 'none',
    background: 'transparent',
  },
  deleteButton: {
    border: 'none',
    background: 'transparent',
    color: '#dc3545',
    cursor: 'pointer',
    padding: 0,
    fontSize: '14px',
  },
};

export default SellerProductView;